const routes = {
    jobList: "/",
    detailedJob: "/job/:id",
};

export default routes;